import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { Project } from '../model/project';
import { AuthenticationService } from '../login/authentication.service';
import { TranslateService } from '../translate/translate.service';
import { ProjectService } from '../project/project.service';
import { User } from '../model/user';
import {CreateObjectDialogComponent} from '../createObjectDialog/create-object-dialog.component';
import {userType, UserTypeEnum} from '../model/userTypeEnum';
import {FormModel} from '../model/forms/form-model';
import {InputModel} from '../model/forms/input-model';
import {Client} from '../model/client';
import {SharedRefreshService} from '../service/sharedRefreshService';
import {ClientFormUtil} from '../model/FormUtil/clientFormUtil';
import {ProjectFormUtil} from '../model/FormUtil/projectFormUtil';
import {DOCUMENT} from '@angular/common';
import * as moment from 'moment';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@Component({

    selector: 'main',

    template: `
      <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
        <a class="navbar-brand" href="#">
          <img src="https://getbootstrap.com/docs/4.3/assets/brand/bootstrap-solid.svg" width="30" height="30" class="d-inline-block align-top" alt="">
          JuJu
        </a>
        <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
          </ul>
          <form class="form-inline my-2 my-lg-0">
            <ul class="navbar-nav mr-auto">
                <button class="btn btn-outline-primary" (click)="dashboard()" data-toggle="tooltip" data-placement="bottom" title="Dashboard">
                    <img src="../../assets/images/Dashboard-icon.png" width="24" height="24"/>
                </button>
              <li class="nav-item dropdown">
                <div class="btn-group">
                    <button  class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Launch
                    </button>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <a class="dropdown-item hand" (click)="showAddProject()"><img alt="icon" class="icon" src="../../assets/images/261.png">New Project</a>
                      <a class="dropdown-item hand" (click)="showAddClient()"><img alt="icon" class="icon" src="../../assets/images/075.png">New Client</a>
                    </div>
                </div>
              </li>
            </ul>
            <ul class="navbar-nav mr-auto">
              <li *ngFor="let lang of supportedLanguages">
                <button  (click)="selectLang(lang.value)" class="btn btn-outline-info my-2 my-sm-0" [class.active]="isCurrentLang(lang.value)">
                  <span class="flag-icon flag-icon-{{lang.value==='en'?'us':'fr'}}"> </span>
                </button>
              </li>
            </ul>
              <button class="btn btn-outline-warning my-2 my-sm-0" (click)="logout()" data-toggle="tooltip" data-placement="bottom" title="Logout">
                  <img  src="../../assets/images/45.png" alt="logout" width="32" height="32"/>
              </button>
              <button class="btn btn-outline-primary my-2 my-sm-0" (click)="preferences()" data-toggle="tooltip" data-placement="bottom" title="Settings & Preferences">
                  <img alt="iconControlPanel" src="../../assets/images/22.png" width="32" height="32"/>
              </button>
          </form>
            <a href="https://nomadlogic.atlassian.net"><button class="btn btn-outline-primary my-2 my-sm-0" data-toggle="tooltip"  data-placement="bottom" title="Help">
                <img alt="iconHelp" src="../../assets/images/168.png" width="32" height="32px"/>
            </button></a>
        </div>
      </nav>
    <div class="d-flex" id="wrapper">
        <project-list [projects]="_projects" class="project-list"></project-list>
        <!-- <div class="col-xs-12 col-sm-8 col-sm-offset-4 col-md-10 col-md-offset-2 main">-->
          <div id="page-content-wrapper">
            <router-outlet></router-outlet>
          </div>
        <!--</div>-->
    </div>
    <create-object-dialog (NewObjectEvent)="onNewEvent($event)" [modelObject]="intentModel" [formModel]="formModel" [wizardTitle]="formModel.title"></create-object-dialog>
    <!--<create-client-dialog (NewClient)="onNewClient()"></create-client-dialog>-->`,

    styles: [`.navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:hover, .navbar-inverse .navbar-nav > .open > a:focus {
        color: #ffffff;
        background-color:transparent;}
    .icon{height:25px;width:25px;margin-right: 5px;}
    .btn-outline-warning,.btn-outline-primary{padding:0;}
    .project-list{
      background-color: #343a40;
    }
    .dropdown-item{font-family: Verdana;font-size: small;}
    .dropdown-item:hover{background-color: #245edb; color:#FFFFFF;}
    button{margin-right:10px;}
    #page-content-wrapper{
        background-image: url("../../assets/images/vistaLight.jpg");
        background-size: cover;
    }
    `
    ]


})

export class MainComponent implements OnInit {
  private _projects: Project[];
  private errorMessage: string;
  public supportedLanguages: any[];

  private intentModel:(Project|Client) = new Project();

  private formModel:FormModel;

  @ViewChild(CreateObjectDialogComponent) private createProjectComponent:CreateObjectDialogComponent;

  constructor( @Inject(DOCUMENT) public doc , private _projectService: ProjectService, private _router: Router, private _authenticationService: AuthenticationService, private _translate: TranslateService, private _refresh:SharedRefreshService) {
      console.log('constructor called from main');

      _refresh.refreshEmitted.subscribe((val) => {
          if(val) {
              this.getProjects();
          }
      });
  }

    dashboard() {
      this._router.navigate(['/dashboard']);
    }

    logout() {
        this._authenticationService.logout();
        this._router.navigate(['/login']);
    }

    ngOnInit() {
        console.log('ng Oninit called');
        // standing data
        this.supportedLanguages = [
            { display: 'English', value: 'en' },
            { display: 'Français', value: 'fr' }
        ];

        if (localStorage.getItem('language')) {
            this.selectLang(localStorage.getItem('language'));
        } else {
            this.selectLang('en');
        }

        const user: User = this._authenticationService.user;
        // TODO: create an enum
        console.log('User from main'+user);
        console.log(user.Role);
        // TODO: this part of code is redundant.It is currently patched to work. We'll have this section of if to manage users based on roles.
        if (UserTypeEnum.getEnumType(user.Role) === userType.User) {
            this.getProjects();
        } else {
            console.log('called else from main ngOnInit');
            this.getProjects();
        }

        this.formModel = ProjectFormUtil.generateProjectForm();
    }

    private onNewProject() {
        this.createProjectComponent.toggleDialog();
        const user: User = this._authenticationService.user;
        console.log(user);
        console.log(user.Role);
        // TODO: this part of code is redundant.It is currently patched to work. We'll have this section of if to manage users based on roles.
        if (UserTypeEnum.getEnumType(user.Role) === userType.User) {
            this.getProjects();
        } else {
            this.getProjects();
        }
    }

    // TODO: Try to put all these kind of methods in a util class
    getProjects() {
        this._projectService.getProjects()
            .subscribe(
                projects => {
                     this._projects = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(projects,Project);// new Array<Project>();
                    console.log(this._projects);

                    const currentDateInMilliseconds = Math.floor(Date.now()/1000)*1000;

                    const projectsForNotif:Project[] = [];

                    for(let i = 0; i< projects.length;i++) {
                      // this._projects.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(projects[i],Project));
                      if(currentDateInMilliseconds - Number(projects[i].createdDate)<345600000) {
                          projectsForNotif.push(projects[i]);

                      }
                    }

                    localStorage.setItem('projectsToNotif', JSON.stringify(projectsForNotif));
                },
                error => this.errorMessage = <any>error);
    }


    getClientProjects(token) {
        this._projectService.getClientProjects(token)
            .subscribe(
                projects => {
                    this._projects = projects;

                },
                error => this.errorMessage = <any>error);
    }

    isCurrentLang(lang: string) {
        return lang === this._translate.currentLang;
    }

    selectLang(lang: string) {
        this._translate.use(lang);
        localStorage.setItem('language', lang);
    }

    showAddProject() {
        this.intentModel = new Project();
        this.formModel = ProjectFormUtil.generateProjectForm();
        this.createProjectComponent.toggleDialog();
    }

    showAddClient() {
        this.intentModel = new Client();
        this.formModel = ClientFormUtil.generateClientForm();
        this.createProjectComponent.toggleDialog();
    }


    onNewClient() {
      this.createProjectComponent.toggleDialog();
    }


  preferences() {
    this._router.navigate(['/preferences']);
  }

  onNewEvent(event:string) {
    switch (event) {
      case 'project':this.onNewProject();break;
      case 'client': this.onNewClient();break;
    }
  }
}
